import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, 
    // Icon 
} from "antd";
// import Datasheet from "react-datasheet";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import { SchemesService } from "services";
import "styles/form.css";
import { BUSINESS_PROGRAM_FORM_FIELDS } from "constants/form-fields";
import { 
    SUPPLY_CHAIN_ROLE_TYPE_CHOICE,
    // PROGRAM_TYPES
} from "constants/enums";
import { List } from "immutable";
const FormItem = Form.Item;

class BusinessProgramDetailsForm extends React.PureComponent {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        product_list: [],
        parent_programs: null
    };

    onSearchBusinessProduct = (str) => 
        SchemesService.getBusinessProductList(str).then(({data}) => ({
            data: data.results
        }));

    onSearchCompany = (str) => {
        return SchemesService.entityLookup(str, {
            supply_chain_role: this.props.form.getFieldValue("program_type")
        }).then(({data}) => ({
            data: data.results
        }));
    }

    onSelectBusinessProduct = (val) => {
        this.props.form.setFieldsValue({
            program_type: null,
            company: null,
            parent_program: null
        });
        let productObj = this.props.business_products.find(_ => _.id === val);
        if(productObj.anchor_type === productObj.seller_type) {
            this.props.form.setFieldsValue({
                program_type: SUPPLY_CHAIN_ROLE_TYPE_CHOICE.get("Master Program")
            });
            this.setState({
                product_list: [SUPPLY_CHAIN_ROLE_TYPE_CHOICE.get("Master Program")]
            });
        } else {
            this.setState({
                product_list: [productObj.anchor_type, productObj.seller_type]
            });
        }
    }

    onSearchBusinessProgram = (str) => {
        return SchemesService.searchBusinessProgram(str).then(({data}) => {
            return  {
                data: data.results.map(_ => ({
                    label: `${_.company.name} | ${_.business_product_code}`,
                    value: _.id,
                    id: _.id
                }))
            };
        });
    } 
    
    getParentProgramDetails = (val) => {
        this.props.getParentProgramDetails(val.id);
    };

    saveProgramDetails = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            let product_type = values.business_product.seller_type === values.business_product.anchor_type ? 1 : 2;
            let newValues = {
                ...values,
                company: values.company.id,
                parent_program: values.parent_program ? values.parent_program.id : null,
                program_type: product_type
            };
            this.props.values && this.props.values.get("id") ? this.props.updateBusinessProgram(newValues) : this.props.saveProgramDetails(newValues);
        }); 
    }

    render() {
        return (
            <div className={"p-10"}>
                <Form
                    className={cx("form", "br-3")}
                >
                    <div className={"form-row"}>
                        {BUSINESS_PROGRAM_FORM_FIELDS.map((field, fieldName) => {
                            if(fieldName === "business_product") {
                                field.options = this.props.business_products && this.props.business_products.length ? new List(this.props.business_products.map(_ => ({
                                    label: _.short_name,
                                    value: _.id
                                }))) : new List([]);
                                field.onSelect = this.onSelectBusinessProduct;
                            }
                            if(fieldName === "program_type") {
                                let product = this.props.form.getFieldValue("business_product");
                                if(product) {
                                    field.disabled = false;
                                }
                                field.options = product ? SUPPLY_CHAIN_ROLE_TYPE_CHOICE.filter(_ => this.state.product_list.includes(_)).map((v,k) => ({
                                    label: k,
                                    value: v
                                })).toList() : new List([]);
                            }
                            if(fieldName === "parent_program") {
                                let company = this.props.form.getFieldValue("company");
                                if(company) {
                                    field.disabled = false;
                                }
                                field.onSearch = this.onSearchBusinessProgram;
                            }
                            if(fieldName === "company") {
                                let program_type = this.props.form.getFieldValue("program_type");
                                if(program_type) {
                                    field.disabled = false;
                                } else {
                                    field.disabled = true;
                                }
                                field.onSearch = this.onSearchCompany;
                            }
                            
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                            // <Datasheet 
                            //     data={}
                            // />
                        }).toList()}
                    </div>
                    <div className="d-flex justify-content-flex-end">
                        <FormItem className={cx("mr-5")}>
                            <Button key="save" type="primary" icon={"plus"} onClick={this.saveProgramDetails}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                        </FormItem>
                    </div>
                </Form>
            </div>
        );
    }
}

BusinessProgramDetailsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    saveProgramDetails: PropTypes.func,
    updateBusinessProgram: PropTypes.func,
    getParentProgramDetails: PropTypes.func,
    business_products: PropTypes.array

};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
        values
            .map((value, key) => {
                if(key === "business_product") {
                    return Form.createFormField({
                        value: value && value.id
                    });
                }
                if(key === "parent_program") {
                    return Form.createFormField({
                        value: value && {
                            label: value.label ? value.label : `${value.company.name} | ${value.business_product.code}`,
                            value: value.id,
                            id: value.id
                        }
                    });
                }
                return Form.createFormField({
                    value
                });
            }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
        if(changedValues.business_product) {
            values.program_type = null;
        }
    }
})(BusinessProgramDetailsForm);